export interface SectionConfig {
  id: string;
  labelKey: string;
  color: string;
}

export const SECTIONS: SectionConfig[] = [
  { id: "home",       labelKey: "navigation.home",       color: "#3B82F6" },
  { id: "about",      labelKey: "navigation.about",      color: "#3B82F6" },
  { id: "marine",     labelKey: "navigation.marine",     color: "#3B82F6" },
  { id: "containers", labelKey: "navigation.containers", color: "#F97316" },
  { id: "scan",       labelKey: "navigation.scan",       color: "#60A5FA" },
  { id: "projects",   labelKey: "navigation.projects",   color: "#2DD4BF" },
  { id: "contact",    labelKey: "navigation.contact",    color: "#8892B0" },
];

export const SECTION_COLOR: Record<string, string> = Object.fromEntries(
  SECTIONS.map((s) => [s.id, s.color])
);
